import Size from '@enums/Size';
import Typography from '@/components/Typography';
import ParagraphSizeProps from './utils/ParagraphSizeProps';

const Paragraph = ({
  children,
  color,
  overrideStyles,
  size = Size.MEDIUM,
  sx,
}) => {
  const sizeProps = ParagraphSizeProps[size];

  return (
    <Typography
      sx={{
        ...sizeProps,
        color: color ?? 'inherit',
        mb: 1,
        fontWeight: 400,
        ...overrideStyles,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};

export default Paragraph;
